"use strict";
import { useCallback, useEffect, useState } from "react";
import { getChainInfo } from "features/chains/chainInfo";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
import { isTestnetChain } from "features/chains/utils";
import { WalletEventName } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send";
export function useFilterCallbacks(chainId, modalName) {
  const [chainFilter, setChainFilter] = useState(chainId);
  const [parsedChainFilter, setParsedChainFilter] = useState(null);
  const [searchFilter, setSearchFilter] = useState(null);
  const [parsedSearchFilter, setParsedSearchFilter] = useState(null);
  const { chains: enabledChains } = useEnabledChains();
  useEffect(() => {
    const splitSearch = searchFilter?.split(" ");
    const maybeChainName = splitSearch?.[0]?.toLowerCase();
    const chainMatch = getNativeCurrencyNames(enabledChains).find(
      (currency) => currency.name.startsWith(maybeChainName ?? "")
    );
    const search = splitSearch?.slice(1).join(" ");
    if (!chainFilter && chainMatch && search) {
      setParsedChainFilter(chainMatch.chainId);
      setParsedSearchFilter(search);
    } else {
      setParsedChainFilter(null);
      setParsedSearchFilter(null);
    }
  }, [searchFilter, chainFilter, enabledChains]);
  useEffect(() => {
    setChainFilter(chainId);
  }, [chainId]);
  const onChangeChainFilter = useCallback(
    (newChainFilter) => {
      setChainFilter(newChainFilter);
      sendAnalyticsEvent(WalletEventName.NetworkFilterSelected, {
        chain: newChainFilter ?? "All",
        modal: modalName
      });
    },
    [modalName]
  );
  const onClearSearchFilter = useCallback(() => {
    setSearchFilter(null);
  }, []);
  const onChangeText = useCallback((newSearchFilter) => setSearchFilter(newSearchFilter), [setSearchFilter]);
  return {
    chainFilter,
    parsedChainFilter,
    searchFilter,
    parsedSearchFilter,
    onChangeChainFilter,
    onClearSearchFilter,
    onChangeText
  };
}
const getNativeCurrencyNames = (chains) => chains.map((chainId) => {
  return isTestnetChain(chainId) ? false : {
    chainId,
    name: getChainInfo(chainId).nativeCurrency.name.toLowerCase()
  };
}).filter(Boolean);
